module.exports = __webpack_public_path__ + "static/media/loading.f1b12302.svg";